import axios from "axios";
import { getToken } from "./services/storageService";
import { handleSubscriptionRequired } from "./subscriptionRequired";
import { handleClientClosed } from "./clientClosed";

// La instancia por defecto de axios es la que usan las peticiones de negocio: el 402 de suscripción también se maneja aquí.
axios.interceptors.response.use((response) => response, handleSubscriptionRequired);
axios.interceptors.response.use((response) => response, handleClientClosed);

export const getRequest = (endPoint = '', useToken = false)=> {
    const config = {
        headers: { 'Authorization':`Bearer ${getToken()}` }
    };
    return axios.get(`${process.env.REACT_APP_COACH_API_BASE_URL}/${endPoint}`, useToken ? config : {});
}

export const postRequest = (endPoint = '', body = {}, useToken = false)=> {
    const config = {
        headers: { 'Authorization':`Bearer ${getToken()}` }
    };
    return axios.post(`${process.env.REACT_APP_COACH_API_BASE_URL}/${endPoint}`, body, useToken ? config : {});
}

export const putRequest = (endPoint = '', body = {}, useToken = false)=> {
    const config = {
        headers: { 'Authorization':`Bearer ${getToken()}` }
    };
    return axios.put(`${process.env.REACT_APP_COACH_API_BASE_URL}/${endPoint}`, body, useToken ? config : {});
}

export const deleteRequest = (endPoint = '', useToken = false)=> {
    const config = {
        headers: { 'Authorization':`Bearer ${getToken()}` }
    };
    return axios.delete(`${process.env.REACT_APP_COACH_API_BASE_URL}/${endPoint}`, useToken ? config : {});
}


export const dataRequest = (endPoint = '', data = null, useToken = false)=> {
    const config = {
        headers: {
            'Authorization':`Bearer ${getToken()}`,
            'Content-Type': 'multipart/form-data'
        }
    };
    return axios.post(`${process.env.REACT_APP_COACH_API_BASE_URL}/${endPoint}`, data, useToken ? config : {});
}


